var map = {
	"./0x.png": 1115,
	"./1inch.png": 1116,
	"./BAL-logo.png": 1117,
	"./BAT-logo.png": 1118,
	"./BUSD-logo.png": 1119,
	"./COMP-logo.png": 1120,
	"./CRV-icon.png": 1121,
	"./CRV-logo.jpg": 1122,
	"./CRV-logo.png": 1123,
	"./DAI-logo.png": 1124,
	"./ERPH0DMWsAEWBjy.jpg": 1125,
	"./ETH-icon.png": 1126,
	"./ETH-logo.png": 1127,
	"./FTM-logo.png": 1128,
	"./IEARN-icon.png": 1129,
	"./KNC-logo.png": 1130,
	"./LEND-logo.png": 1131,
	"./LINK-logo.png": 1132,
	"./MANA-logo.png": 1133,
	"./MKR-logo.png": 1134,
	"./MUSD-logo.png": 1135,
	"./OPYN-logo.png": 1136,
	"./REP-logo.png": 1137,
	"./SAI-logo.png": 1138,
	"./SNX-logo.png": 1139,
	"./SUSD-logo.png": 1140,
	"./TUSD-logo.png": 1141,
	"./UMA-logo.png": 1142,
	"./USDC-logo.png": 1143,
	"./USDT-logo.png": 1144,
	"./YFI-logo.png": 1145,
	"./ZRX-logo.png": 1146,
	"./aLINK-logo.png": 1147,
	"./aave.png": 1148,
	"./aave.svg": 1149,
	"./aavev2.svg": 1150,
	"./about-image-placeholder.png": 1151,
	"./adelphi.png": 1152,
	"./akropolis.svg": 1153,
	"./alpha-homora.jpg": 1154,
	"./ampleforth.svg": 1155,
	"./ampleforthtokengeyser.png": 1156,
	"./amplf.png": 1157,
	"./anchor.svg": 1158,
	"./argent.png": 1159,
	"./armor-circle-logo.svg": 176,
	"./armor-logo.svg": 528,
	"./armor.png": 177,
	"./armor_background.jpg": 529,
	"./arnxm.png": 178,
	"./arrow-right.svg": 1160,
	"./badger.png": 1161,
	"./badgerdao.png": 1162,
	"./balancer.png": 1163,
	"./balancer.svg": 1164,
	"./bancor.png": 1165,
	"./benchmark-protocol.png": 1166,
	"./binance.png": 1167,
	"./binance.svg": 1168,
	"./blockFi.svg": 1169,
	"./bunnypancake.svg": 1170,
	"./bzx.png": 1171,
	"./cUSDC-logo.png": 1172,
	"./cUSDT-logo.png": 1173,
	"./celsius.svg": 1174,
	"./close-icon.svg": 1175,
	"./cofix.jpg": 1176,
	"./coinbase.png": 1177,
	"./coinbaseWalletIcon.svg": 1178,
	"./coinbase_mini.png": 1179,
	"./compound.png": 1180,
	"./compoundv2.png": 1181,
	"./connect_wallet.svg": 530,
	"./corn-icon.svg": 1182,
	"./cover.jpg": 1183,
	"./cream.png": 1184,
	"./curve-3crv.png": 1185,
	"./curve.png": 1186,
	"./curvefi.jpg": 1187,
	"./dai.png": 1188,
	"./ddex.jpg": 1189,
	"./ddex.png": 1190,
	"./defipulse.png": 1191,
	"./defisnap.svg": 1192,
	"./defizap.png": 1193,
	"./deversifi.png": 1194,
	"./dforce-logo.jpg": 1195,
	"./dforce.svg": 1196,
	"./discord.svg": 1197,
	"./dodo.png": 1198,
	"./dodoexchange.png": 1199,
	"./dxdao.png": 1200,
	"./dydx.jpg": 1201,
	"./dydx.png": 1202,
	"./dydx.svg": 1203,
	"./eth.png": 1204,
	"./eth2.jpg": 1205,
	"./ethereum.png": 1206,
	"./etherscan.png": 1207,
	"./etherum.png": 1208,
	"./exclamation.svg": 1209,
	"./flexa.png": 1210,
	"./fonts/WorkSans-VariableFont_wght.ttf": 1211,
	"./fortmaticIcon.png": 1212,
	"./ftx.svg": 1213,
	"./gasprice.png": 1214,
	"./gemini.png": 1215,
	"./gift-box.svg": 1216,
	"./github.svg": 1217,
	"./gnosis-multisig.png": 1218,
	"./gnosis-safe.png": 1219,
	"./gnosis_safe.png": 1220,
	"./harvest.png": 1221,
	"./hegic.png": 1222,
	"./hero_armor_background.jpg": 409,
	"./hodlnaut.svg": 1223,
	"./iDAI-logo.png": 1224,
	"./icn-aethereum.svg": 1225,
	"./icn-ledger.svg": 1226,
	"./icn-metamask.svg": 1227,
	"./idex.png": 1228,
	"./idle.png": 1229,
	"./iearn.png": 1230,
	"./ill_coming_soon.svg": 1231,
	"./ill_coming_soon_no_shadow.svg": 410,
	"./inlock.png": 1232,
	"./keeperdao.jpg": 1233,
	"./kraken.png": 1234,
	"./kyber.png": 1235,
	"./kybernetwork.png": 1236,
	"./langs/en.svg": 531,
	"./langs/ja.svg": 532,
	"./langs/ko.svg": 533,
	"./langs/ru.svg": 534,
	"./langs/zh.svg": 535,
	"./ledger.png": 1237,
	"./ledn.svg": 1238,
	"./lendf.png": 1239,
	"./lendf.svg": 1240,
	"./liquity.png": 1241,
	"./logos/0x.svg": 536,
	"./logos/0x_v3.svg": 537,
	"./logos/1inch.svg": 538,
	"./logos/aave.svg": 539,
	"./logos/aave_v2.svg": 540,
	"./logos/adelphi.svg": 541,
	"./logos/akropolis.svg": 542,
	"./logos/alink.svg": 543,
	"./logos/alpha-homora.svg": 544,
	"./logos/ampleforth.svg": 545,
	"./logos/argent.svg": 546,
	"./logos/armor.svg": 547,
	"./logos/arnxm.svg": 548,
	"./logos/badger_dao.png": 1242,
	"./logos/balancer.svg": 549,
	"./logos/bancor.svg": 550,
	"./logos/bat.svg": 551,
	"./logos/binance.svg": 552,
	"./logos/block_fi.svg": 553,
	"./logos/busd.svg": 554,
	"./logos/bzx.svg": 555,
	"./logos/celsius.svg": 556,
	"./logos/check_circle.svg": 291,
	"./logos/cofix.png": 1243,
	"./logos/coinbase.svg": 557,
	"./logos/coinbase_wallet.svg": 558,
	"./logos/compound.svg": 559,
	"./logos/compound_v2.svg": 560,
	"./logos/connect_disconnected.svg": 292,
	"./logos/connect_wallet.svg": 561,
	"./logos/cover.jpg": 1244,
	"./logos/cream.svg": 562,
	"./logos/curve.svg": 563,
	"./logos/cusdc.svg": 564,
	"./logos/cusdt.svg": 565,
	"./logos/dai.svg": 566,
	"./logos/ddex.svg": 567,
	"./logos/defi_pulse.svg": 568,
	"./logos/defisnap.svg": 569,
	"./logos/defizap.svg": 570,
	"./logos/deversifi.svg": 571,
	"./logos/dforce.svg": 572,
	"./logos/dodo.svg": 573,
	"./logos/dxdao.svg": 574,
	"./logos/dydx.svg": 575,
	"./logos/eth.svg": 576,
	"./logos/etherscan.svg": 577,
	"./logos/flexa.png": 1245,
	"./logos/fortmatic.svg": 578,
	"./logos/ftm.svg": 579,
	"./logos/gas_price.svg": 293,
	"./logos/gemini.svg": 580,
	"./logos/gift.svg": 581,
	"./logos/gnosis_multisig.png": 1246,
	"./logos/gnosis_safe.png": 1247,
	"./logos/hegic.svg": 582,
	"./logos/hodlnaut.svg": 583,
	"./logos/icn_aethereum.svg": 584,
	"./logos/icn_ledger.svg": 585,
	"./logos/icn_metamask.svg": 586,
	"./logos/idai.png": 1248,
	"./logos/idex.svg": 587,
	"./logos/idle.svg": 588,
	"./logos/iearn.svg": 589,
	"./logos/inlock.svg": 590,
	"./logos/keeperdao.svg": 591,
	"./logos/knc.svg": 592,
	"./logos/kraken.svg": 593,
	"./logos/ledn.svg": 594,
	"./logos/lend.svg": 595,
	"./logos/lendf.png": 1249,
	"./logos/link.svg": 596,
	"./logos/lock.svg": 597,
	"./logos/maker_dao.svg": 598,
	"./logos/mana.svg": 599,
	"./logos/medium.svg": 600,
	"./logos/melon.svg": 601,
	"./logos/metamask.svg": 602,
	"./logos/metamask_right.svg": 603,
	"./logos/moloch.png": 1250,
	"./logos/mooniswap.svg": 604,
	"./logos/mstable.svg": 605,
	"./logos/musd.png": 1251,
	"./logos/nexo.svg": 606,
	"./logos/nexus_mutants.svg": 607,
	"./logos/nft.png": 1252,
	"./logos/notional.png": 1253,
	"./logos/nucypher.svg": 608,
	"./logos/nuo.png": 1254,
	"./logos/o_curve.svg": 609,
	"./logos/opyn.svg": 610,
	"./logos/paraswap.png": 1255,
	"./logos/perpetual.jpg": 1256,
	"./logos/pooltogether.svg": 611,
	"./logos/portis.svg": 612,
	"./logos/protect.svg": 613,
	"./logos/ren.svg": 614,
	"./logos/rep.svg": 615,
	"./logos/safe.svg": 616,
	"./logos/sai.svg": 617,
	"./logos/saturn_dao.png": 1257,
	"./logos/set_protocol.svg": 618,
	"./logos/snx.svg": 619,
	"./logos/squarelink.png": 1258,
	"./logos/stats.svg": 620,
	"./logos/susd.png": 1259,
	"./logos/sushiswap.svg": 621,
	"./logos/synthetix.svg": 622,
	"./logos/tbtc.svg": 623,
	"./logos/telegram.svg": 624,
	"./logos/tornado.svg": 625,
	"./logos/torus.svg": 626,
	"./logos/totle.svg": 627,
	"./logos/trezor.svg": 628,
	"./logos/truefi.jpg": 1260,
	"./logos/truffle.svg": 629,
	"./logos/trust_wallet.svg": 630,
	"./logos/tusd.svg": 631,
	"./logos/twitter.svg": 632,
	"./logos/uma.svg": 633,
	"./logos/uniswap.svg": 634,
	"./logos/usdc.svg": 635,
	"./logos/usdt.svg": 636,
	"./logos/wallet_connect.svg": 637,
	"./logos/wbtc.svg": 638,
	"./logos/yam.png": 1261,
	"./logos/yearn_finance.svg": 639,
	"./maker_dao.png": 1262,
	"./makerdao.png": 1263,
	"./makerdaomcd.png": 1264,
	"./medium.svg": 1265,
	"./melon.png": 1266,
	"./metamask-right.png": 180,
	"./metamask.png": 1267,
	"./metamask.svg": 1268,
	"./moloch.png": 1269,
	"./mooniswap.png": 1270,
	"./mooniswap.svg": 1271,
	"./mstable.png": 1272,
	"./mstable.svg": 1273,
	"./new_armor_background.jpg": 294,
	"./nexo.svg": 1274,
	"./nexus-mutants.png": 1275,
	"./nft.png": 1276,
	"./notional.png": 1277,
	"./nu_cypher.png": 1278,
	"./nucypher.svg": 1279,
	"./nuo.png": 1280,
	"./oCurve-logo.svg": 1281,
	"./oneinch.svg": 1282,
	"./opyn.png": 1283,
	"./originusd.png": 1284,
	"./oxv3.png": 1285,
	"./pancakeswap.svg": 1286,
	"./paraswap.png": 1287,
	"./perpetual.jpg": 1288,
	"./pool_together.png": 1289,
	"./pooltogether.png": 1290,
	"./portisIcon.png": 1291,
	"./reflexer.png": 1292,
	"./ren.svg": 1293,
	"./renvm.png": 1294,
	"./safe.png": 1295,
	"./saturn_dao.png": 1296,
	"./saturndao.png": 1297,
	"./set_protocol.png": 1298,
	"./squarelink.png": 1299,
	"./stakedao.png": 1300,
	"./sushiswap.jpg": 1301,
	"./synthetix.png": 1302,
	"./synthetix.svg": 1303,
	"./tbtc.svg": 1304,
	"./telegram.svg": 1305,
	"./thorchain.svg": 1306,
	"./tokensets.png": 1307,
	"./tornado.png": 1308,
	"./tornadocash.png": 1309,
	"./torus.jpg": 1310,
	"./totle.png": 1311,
	"./trezor.png": 1312,
	"./truefi.jpg": 1313,
	"./truffle.png": 1314,
	"./trustWallet.png": 1315,
	"./twitter.svg": 1316,
	"./uma.png": 1317,
	"./uniswap-logo.png": 1318,
	"./uniswap.png": 1319,
	"./uniswap.svg": 1320,
	"./uniswapv2.png": 1321,
	"./uniswapv3.svg": 1322,
	"./venus.svg": 1323,
	"./vesper.jpeg": 1324,
	"./wBTC-icon.png": 1325,
	"./wBTC-logo.png": 1326,
	"./walletConnectIcon.svg": 1327,
	"./wbtc.svg": 1328,
	"./yam.png": 1329,
	"./yam_finance.png": 1330,
	"./ycUSDC-logo.png": 1331,
	"./ycUSDT-logo.png": 1332,
	"./yearn.svg": 1333,
	"./yearnfinance.png": 1334,
	"./yield.jpg": 1335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;